
import { linkAppStore, linkPlayStore } from '@/helpers/constants'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppDownload',
  setup() {
    return {
      linkAppStore,
      linkPlayStore
    }
  },
  methods: {
    openLink(link: string) {
      window.open(link, '_blank')
    }
  }
})
